import React, { useEffect, useState } from "react";
import { generateClient } from "aws-amplify/api";
import { listSlumSoccerNews } from "../graphql/queries";
import { NewsCard } from "../components/NewsCard";

const client = generateClient();

const getNewsDate = (news) => {
  try {
    // Check if ef1 exists and is a string before parsing
    const ef1 =
      typeof news.ef1 === "string" ? JSON.parse(news.ef1) : news.ef1;

    // Parse date, handling potential different formats
    return ef1?.date ? new Date(ef1.date) : new Date(0);
  } catch (error) {
    console.error(`Error parsing date for news item:`, news);
    return new Date(0);
  }
};

export function News(props) {
  const [data, setData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      let pendingData = await client.graphql({
        query: listSlumSoccerNews,
      });

      // Sort news items by date, newest first
      const sortedNewsItems = pendingData["data"][
        "listSlumSoccerNews"
      ].items.sort((a, b) => {
        const dateA = getNewsDate(a);
        const dateB = getNewsDate(b);
        return dateB - dateA; // Newest first
      });

      setData(sortedNewsItems);
    } catch (error) {
      console.error("Error fetching or sorting news items:", error);
    }
  };

  return (
    <section className="py-16  bg-gradient-to-b from-gray-50 to-gray-100, animate__animated animate__bounceInUp">
      <div className="container mx-auto px-9">
        <div className="text-center mb-5">
          <h2 className="text-4xl font-bold text-orange-500 relative inline-block -mt-5 ">
            News
            <div className="h-1 w-full bg-orange-500 mt-2"></div>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {data.map((news) => (
            <NewsCard key={news.newsId} news={news} />
          ))}
        </div>
      </div>
    </section>
  );
}